var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-field-address" }, [
    _c("label", { staticClass: "label-hr" }, [_vm._v(_vm._s(_vm.field.title))]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "address-fields" },
      _vm._l(_vm.editfield.address, function(sub, subKey) {
        return _c(
          "li",
          { key: subKey, staticClass: "address-list-item" },
          [
            _c("div", { staticClass: "address-field-header" }, [
              _c(
                "div",
                { staticClass: "header-left" },
                [
                  _c("i", { staticClass: "el-icon-menu drag-handle" }),
                  _vm._v(" "),
                  _c("el-checkbox", {
                    model: {
                      value: _vm.editfield.address[subKey].checked,
                      callback: function($$v) {
                        _vm.$set(_vm.editfield.address[subKey], "checked", $$v)
                      },
                      expression: "editfield.address[subKey].checked"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "field-label-text" }, [
                    _vm._v(_vm._s(sub.label || subKey))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "header-right" }, [
                _c(
                  "label",
                  { staticClass: "required-checkbox-wrapper" },
                  [
                    _c("el-checkbox", {
                      model: {
                        value: _vm.editfield.address[subKey].required,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.editfield.address[subKey],
                            "required",
                            $$v
                          )
                        },
                        expression: "editfield.address[subKey].required"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Required")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("i", {
                  class: [
                    _vm.show_details[subKey]
                      ? "el-icon-caret-top"
                      : "el-icon-caret-bottom",
                    "el-icon-clickable"
                  ],
                  on: {
                    click: function($event) {
                      return _vm.toggle_show_details(subKey)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            "country_select" !== subKey
              ? [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show_details[subKey],
                          expression: "show_details[subKey]"
                        }
                      ],
                      staticClass: "address-input-fields"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "address-input-item" },
                        [
                          _c("label", { staticClass: "contactum-label" }, [
                            _vm._v("Label")
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            model: {
                              value: _vm.editfield.address[subKey].label,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editfield.address[subKey],
                                  "label",
                                  $$v
                                )
                              },
                              expression: "editfield.address[subKey].label"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "address-input-item" },
                        [
                          _c("label", { staticClass: "contactum-label" }, [
                            _vm._v("Placeholder")
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            model: {
                              value: _vm.editfield.address[subKey].placeholder,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editfield.address[subKey],
                                  "placeholder",
                                  $$v
                                )
                              },
                              expression:
                                "editfield.address[subKey].placeholder"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              : [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show_details[subKey],
                          expression: "show_details[subKey]"
                        }
                      ],
                      staticClass: "address-input-fields"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "address-input-item" },
                        [
                          _c("label", { staticClass: "contactum-label" }, [
                            _vm._v("Label")
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            model: {
                              value: _vm.editfield.address.country_select.label,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editfield.address.country_select,
                                  "label",
                                  $$v
                                )
                              },
                              expression:
                                "editfield.address.country_select.label"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "address-input-item" },
                        [
                          _c("label", { staticClass: "contactum-label" }, [
                            _vm._v("Default Country")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { filterable: "" },
                              model: {
                                value: _vm.default_country,
                                callback: function($$v) {
                                  _vm.default_country = $$v
                                },
                                expression: "default_country"
                              }
                            },
                            _vm._l(_vm.countries, function(country) {
                              return _c("el-option", {
                                key: country.code,
                                attrs: {
                                  label: country.name,
                                  value: country.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "address-input-item panel-field-option-select"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label-title-block contactum-label"
                            },
                            [_vm._v("Country List")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "country-tabs",
                              staticStyle: { display: "flex" },
                              model: {
                                value:
                                  _vm.editfield.address.country_select
                                    .country_list_visibility_opt_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editfield.address.country_select,
                                    "country_list_visibility_opt_name",
                                    $$v
                                  )
                                },
                                expression:
                                  "editfield.address.country_select.country_list_visibility_opt_name"
                              }
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: "all" } },
                                [_vm._v("Show All")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "hide" } },
                                [_vm._v("Hide These")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "show" } },
                                [_vm._v("Only These")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.active_visibility === "hide",
                                  expression: "active_visibility === 'hide'"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { multiple: "", filterable: "" },
                              model: {
                                value: _vm.country_in_hide_list,
                                callback: function($$v) {
                                  _vm.country_in_hide_list = $$v
                                },
                                expression: "country_in_hide_list"
                              }
                            },
                            _vm._l(_vm.countries, function(c) {
                              return _c("el-option", {
                                key: c.code,
                                attrs: { value: c.code, label: c.name }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.active_visibility === "show",
                                  expression: "active_visibility === 'show'"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { multiple: "", filterable: "" },
                              model: {
                                value: _vm.country_in_show_list,
                                callback: function($$v) {
                                  _vm.country_in_show_list = $$v
                                },
                                expression: "country_in_show_list"
                              }
                            },
                            _vm._l(_vm.countries, function(c) {
                              return _c("el-option", {
                                key: c.code,
                                attrs: { value: c.code, label: c.name }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
          ],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "address-input-item" },
      [
        _c("label", { staticClass: "label-title-block contactum-label" }, [
          _vm._v("Autocomplete Provider")
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticStyle: { width: "100%" },
            attrs: { placeholder: "Select provider" },
            model: {
              value: _vm.editfield.autocomplete_provider,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "autocomplete_provider", $$v)
              },
              expression: "editfield.autocomplete_provider"
            }
          },
          [
            _c("el-option", { attrs: { label: "None", value: "none" } }),
            _vm._v(" "),
            _c("el-option", {
              attrs: {
                label: "Google Maps",
                value: "google",
                disabled: !_vm.has_gmap_api
              }
            }),
            _vm._v(" "),
            _c("el-option", {
              attrs: {
                label: "OpenStreetMap / Nominatim (free)",
                value: "html5"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    !_vm.has_gmap_api && _vm.editfield.autocomplete_provider === "google"
      ? _c("small", { staticClass: "ctm-hint ctm-hint--warn" }, [
          _vm._v("\n    Google Maps API key required. Configure it in "),
          _c("strong", [_vm._v("Integrations → Google Map")]),
          _vm._v(".\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.editfield.autocomplete_provider === "html5"
      ? _c("small", { staticClass: "ctm-hint" }, [
          _vm._v(
            "\n    OpenStreetMap (Nominatim) is free — no API key needed. Rate-limited to 1 req/sec; best for low-traffic forms.\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }